/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReceiveTipNotificationActionData
 */
export interface ReceiveTipNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof ReceiveTipNotificationActionData
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof ReceiveTipNotificationActionData
     */
    senderUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ReceiveTipNotificationActionData
     */
    receiverUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ReceiveTipNotificationActionData
     */
    tipTxSignature: string;
    /**
     * 
     * @type {number}
     * @memberof ReceiveTipNotificationActionData
     */
    reactionValue: number;
}

/**
 * Check if a given object implements the ReceiveTipNotificationActionData interface.
 */
export function instanceOfReceiveTipNotificationActionData(value: object): value is ReceiveTipNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "amount" in value && value["amount"] !== undefined;
    isInstance = isInstance && "senderUserId" in value && value["senderUserId"] !== undefined;
    isInstance = isInstance && "receiverUserId" in value && value["receiverUserId"] !== undefined;
    isInstance = isInstance && "tipTxSignature" in value && value["tipTxSignature"] !== undefined;
    isInstance = isInstance && "reactionValue" in value && value["reactionValue"] !== undefined;

    return isInstance;
}

export function ReceiveTipNotificationActionDataFromJSON(json: any): ReceiveTipNotificationActionData {
    return ReceiveTipNotificationActionDataFromJSONTyped(json, false);
}

export function ReceiveTipNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiveTipNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'senderUserId': json['sender_user_id'],
        'receiverUserId': json['receiver_user_id'],
        'tipTxSignature': json['tip_tx_signature'],
        'reactionValue': json['reaction_value'],
    };
}

export function ReceiveTipNotificationActionDataToJSON(value?: ReceiveTipNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'sender_user_id': value.senderUserId,
        'receiver_user_id': value.receiverUserId,
        'tip_tx_signature': value.tipTxSignature,
        'reaction_value': value.reactionValue,
    };
}

